export const getImageUrlFromJson = async (URI) => {
  const placeholderImage = 'assets/img/game/team-placeholder.png';
  try {
    const parts = URI.split('.').at(-1);
    if (parts === 'json') {
      let response = await fetch(URI);
      let responseJson = await response.json();
      return responseJson.image;
    } else {
      return placeholderImage;
    }
  } catch (error) {
    return placeholderImage;
  }
};
